import Typography from "@mui/material/Typography";
import { FC } from "react";
import { COLOR_PRIMARY_MAIN } from "shared/theme/colors";
import { UploadIcon } from "shared/theme/icons/UploadIcon";
import { fileExtensions } from "../../constants";
import { StyledUploadImageWrapper, StyledUploadInput } from "../../styled";
import PreviewImage from "../PreviewImage";

type UploadNewFileProps = {
  imgUrl: string;
  fileSize?: number | null;
  onLogoUploaded: (e: { target: { files: FileList | null } | null }) => void;
  disabled?: boolean;
};

const UploadNewFile: FC<UploadNewFileProps> = ({
  imgUrl,
  fileSize,
  onLogoUploaded,
  disabled,
}) => {
  return (
    <StyledUploadImageWrapper justifyContent={"space-between"}>
      <PreviewImage imgUrl={imgUrl} fileSize={fileSize} />
      <StyledUploadInput width={110} flexGrow={0}>
        <UploadIcon />
        <input
          accept={fileExtensions}
          id="upload-new-image"
          type="file"
          multiple={false}
          onChange={onLogoUploaded}
          disabled={disabled}
        />
        <Typography variant="bodyMMedium" color={COLOR_PRIMARY_MAIN}>
          Upload new
        </Typography>
      </StyledUploadInput>
    </StyledUploadImageWrapper>
  );
};

export default UploadNewFile;
